module.exports = __webpack_public_path__ + "img/ic_wifi.ffa8d292.svg";